module.exports = __webpack_public_path__ + "img/chibueze.58384d2f.jpg";